import React from 'react';
import { useDispatch, useSelector } from '@ecommerce/nest-ssr/common';
import ProductOffersSortDesktop from './components/product-offers-sort-desktop';
import ProductOffersFiltersDesktop from './components/product-offers-filters-desktop';
import ProductOffersActiveFilters from '../components/product-offers-active-filters/product-offers-active-filters';
import { OffersActions, OffersState } from '../../../../../../reducers/offers';
import './product-offers-header-desktop.scss';

const ProductOffersHeaderDesktop: React.FC = () => {
    const dispatch = useDispatch();
    const selected = useSelector((state: { offers: OffersState; }) => state.offers.selectedFilters || []);

    const selectFilters = (selectedFilters: string[]): void => {
        dispatch({ type: OffersActions.SelectFilters, payload: { selectedFilters } });
    };

    const onRemoveFilter = (value: string): void => {
        selectFilters(selected.filter((filter: string) => filter !== value));
    };

    const onClearFilters = (): void => {
        selectFilters([]);
    };

    return (
        <>
            <div className="product-offers-header-d">
                <ProductOffersFiltersDesktop />
                <ProductOffersSortDesktop />
            </div>
            <ProductOffersActiveFilters
                selectedFilters={selected}
                onRemove={onRemoveFilter}
                onClear={onClearFilters}
            />
        </>
    );
};

export default ProductOffersHeaderDesktop;
